import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer = null,
  size = "lg",
  showCloseButton = true,
  headerRight = null,
}) {
  const maxWidth =
    size === "sm"
      ? "max-w-md"
      : size === "md"
      ? "max-w-xl"
      : size === "xl"
      ? "max-w-6xl"
      : "max-w-3xl";

  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} className="fixed inset-0 z-[9999]">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-120"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-150"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-120"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className={`w-full ${maxWidth} rounded-xl bg-white shadow-2xl overflow-hidden my-8`}
            >
              {(title || showCloseButton || headerRight) && (
                <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
                  <Dialog.Title className="text-lg font-semibold text-primary">
                    {title}
                  </Dialog.Title>

                  <div className="flex items-center gap-2">
                    {headerRight}

                    {showCloseButton && (
                      <button
                        type="button"
                        onClick={onClose}
                        className="h-10 w-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition"
                      >
                        <XMarkIcon className="h-5 w-5 text-gray-700" />
                      </button>
                    )}
                  </div>
                </div>
              )}

              <div className="px-5 py-4 max-h-[calc(90vh-200px)] overflow-y-auto">
                {children}
              </div>

              {footer && (
                <div className="px-5 py-4 border-t border-gray-200 bg-gray-50">
                  {footer}
                </div>
              )}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
